export default {
	NOT_CONFIRMED: 'Not Confirmed',
	CONFIRMED: 'Confirmed',
};
